/** Trim env values — Vercel env vars were stored with trailing \\n literals. */
export function envValue(value: string | undefined): string {
  return (value || "").trim().replace(/\\n$/g, "");
}
